module.exports = __webpack_public_path__ + "img/big_zyyw.ea1c76ac.png";